import React from 'react'
import cx from 'classnames'
import { IProgram } from '../../interfaces'
import { useTranslation } from 'react-i18next'
import { getOpenClosed } from '../../utils'

export interface IMarkerCard extends React.HTMLAttributes<HTMLDivElement> {
  program: IProgram
  className?: string
}

const MarkerCard = function ({ className, program, ...props }: IMarkerCard) {
  const { t } = useTranslation()
  const openClosed = getOpenClosed(program, t)

  return (
    <div className={cx(className, 'ocla-marker-card')} {...props}>
      <a href={`/SearchAgency/${btoa(unescape(encodeURIComponent(program?.agency?.name || '')))}`}>
        <div className='ocla-marker-card__agency'>{program.agency?.name}</div>
      </a>
      <a href={`/ProgramDetails/${program.securityKey}`}>
        <div className='ocla-marker-card__title'>{program.name}</div>
      </a>
      <div className='ocla-marker-card__description'>{program.shortDescription}</div>
      <div className='ocla-marker-card__divider'></div>
      <div className='ocla-marker-card__hours'>
        {program.hoursOfOperation} •
        <div
          className={cx('ocla-marker-card__hours__open-close', {
            green: openClosed === t('filters.open'),
          })}
        >
          {openClosed}
        </div>
      </div>
    </div>
  )
}

export default React.memo(MarkerCard)
